var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 25.75C13.1 25.75 14 24.85 14 23.75H10C10 24.85 10.89 25.75 12 25.75ZM18 19.75V14.75C18 11.68 16.36 9.11 13.5 8.43V7.75C13.5 6.92 12.83 6.25 12 6.25C11.17 6.25 10.5 6.92 10.5 7.75V8.43C7.63 9.11 6 11.67 6 14.75V19.75L4 21.75V22.75H20V21.75L18 19.75Z",
    fill: "#065699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f73be938152be9a7c617e959fbe7323a.svg";
export { ForwardRef as ReactComponent };